import { render, staticRenderFns } from "./client-unit-health-insurance.vue?vue&type=template&id=10b8b5c4&scoped=true&lang=pug&"
import script from "./client-unit-health-insurance.vue?vue&type=script&lang=ts&"
export * from "./client-unit-health-insurance.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b8b5c4",
  null
  
)

export default component.exports